import PropTypes from 'prop-types';
import React, { Fragment } from 'react';
import classNames from 'classnames';
import BodyClassName from 'react-body-classname';
import { FULLPAGE_CLASSNAME } from 'decorators/FullPage/FullPage';
import { isWebview } from 'helpers/isMobile';
import { CmsModules } from 'containers/CmsPage/CmsModules';
import { CmsMetadata } from './modules/CmsMetadata/CmsMetadata';

export class CmsPage extends React.Component {
  state = {
    clearedBanners: false,
  };

  componentWillMount() {
    const { shouldIgnoreUnhandledError, loadCmsPage, path } = this.props;

    if (loadCmsPage) {
      loadCmsPage({ path, shouldIgnoreUnhandledError });
    }
  }

  componentDidMount() {
    const { hideFooter, hideHeader, modules, useReducedFooter, useReducedNavigation } = this.props;

    if (hideHeader) {
      useReducedNavigation(true);
    }

    if (hideFooter) {
      useReducedFooter(true);
    }

    if (modules && modules.length) {
      this.runModuleTasks();
    }
  }

  componentWillReceiveProps(nextProps) {
    const { clearBanners, loadCmsPage, path, modules } = this.props;

    // Banners need to be cleared for logged in users
    if (!this.state.clearedBanners && clearBanners) {
      clearBanners();
      this.setState(() => ({
        clearedBanners: true,
      }));
    }

    if (loadCmsPage && nextProps.path !== path) {
      this.stopModuleTasks();
      loadCmsPage({
        path: nextProps.path,
        shouldIgnoreUnhandledError: nextProps.shouldIgnoreUnhandledError,
      });
    }

    if (!modules.length && nextProps.modules && nextProps.modules.length) {
      this.runModuleTasks(nextProps.modules);
    }
  }

  componentWillUnmount() {
    const { hideFooter, hideHeader, useReducedFooter, useReducedNavigation } = this.props;

    this.stopModuleTasks();

    if (hideHeader) {
      useReducedNavigation(false);
    }

    if (hideFooter) {
      useReducedFooter(false);
    }
  }

  runModuleTasks(modules) {
    const { store, client } = this.context;

    this.moduleSagas = (modules || this.props.modules).reduce((sagas, module) => {
      const sagasToRun = [].concat(module.Component.watchSaga).filter(Boolean);
      sagasToRun.forEach(saga => store.runSaga(saga, client, module.props));
      return sagas.concat(sagasToRun);
    }, []);
  }

  stopModuleTasks() {
    const { store } = this.context;

    if (this.moduleSagas) {
      this.moduleSagas.forEach(store.stopSaga);
    }
  }

  render() {
    const { cmsData, location, modules } = this.props;

    if (!modules) {
      return false;
    }

    return (
      <BodyClassName
        className={classNames({
          [FULLPAGE_CLASSNAME]: location && isWebview(location.search),
        })}>
        <Fragment>
          <CmsMetadata {...(cmsData && cmsData.metadata)} />
          <CmsModules modules={modules} />
        </Fragment>
      </BodyClassName>
    );
  }
}

CmsPage.contextTypes = {
  store: PropTypes.object,
  client: PropTypes.object,
};

CmsPage.propTypes = {
  clearBanners: PropTypes.func,
  loadCmsPage: PropTypes.func,
  useReducedFooter: PropTypes.func,
  useReducedNavigation: PropTypes.func,
  cmsData: PropTypes.shape({
    metadata: PropTypes.object,
  }),
  hideFooter: PropTypes.bool,
  hideHeader: PropTypes.bool,
  shouldIgnoreUnhandledError: PropTypes.bool,
  location: PropTypes.object,
  modules: PropTypes.arrayOf(
    PropTypes.shape({
      Component: PropTypes.func,
      props: PropTypes.object,
    })
  ),
  path: PropTypes.string,
};
